import React, { useRef } from "react";
import { checkChildrenAndSetFocus } from "../common/interactiveCommon";

const KS2IRDNumber = (props) => {
  const { IRD, setIRDData } = props;
  const irdNumberRef = useRef(null);
  const onIRDChange = (e) => {
    checkChildrenAndSetFocus(irdNumberRef.current.children, e.target.name.replace("IRD", ""));
    setIRDData({ name: e.target.name, value: e.target.value });
  };
  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box">
        <div className="mb-3 number">3.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className=" col-md-2 section-label ">
              <label className="">Your IRD number</label>
            </div>
            <div className="col-md-10 pr-3" ref={irdNumberRef}>
              {[...Array(9).keys()].map((i) => (
                <input maxLength="1" type="text" key={`IRD${i + 1}`} id={`IRD${i + 1}`} name={`IRD${i + 1}`} 
                className="form-control text-center" value={IRD[i]} onChange={onIRDChange} style={i==2 || i==5 ? {  marginRight: "10px"} :{}} />
              ))}
              <small className="label-line-height top-space"> &nbsp;&nbsp;If you don’t know your IRD number or you don’t have one, call us on 0800 549 472</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS2IRDNumber;
